export default from './follow-user-button';



// WEBPACK FOOTER //
// ./app/components/follow-user-button/index.js